import { Common, ApiBind } from './common.model';

export class Notification extends Common {

  @ApiBind({ column: 'notice_type' })
  noticeType: string;

  @ApiBind({ column: 'text' })
  text: string;

}
